<section class="users-edit">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <!-- Nav-tabs -->
            <ul
              ngbNav
              #nav="ngbNav"
              [activeId]="1"
              class="nav-tabs justify-content-left"
            >
              <li [ngbNavItem]="1">
                <a ngbNavLink class="nav-link d-flex align-items-center">
                  <i class="ft-user mr-1"></i>
                  <span class="d-none d-sm-block">Account</span>
                </a>
                <ng-template ngbNavContent>
                  <!-- Account content starts -->
                  <div class="mt-2" id="account">
                    <!-- Media object starts -->
                    <div class="media">
                       <img
                        *ngIf="imgUrl"
                        [src]="imgUrl"
                        alt="user edit avatar"
                        class="users-avatar-shadow avatar mr-3 rounded-circle"
                        height="64"
                        width="64"
                      /> 
                       <img
                       *ngIf="courseData?.image && !imgUrl"
                        [src]="imageUrl + courseData?.image"
                        alt="user edit avatar"
                        class="users-avatar-shadow avatar mr-3 rounded-circle"
                        height="64"
                        width="64"
                      />   
                      <!-- <div *ngIf="!courseData.image && !imgUrl"   [class.initial-alpha]="!courseData?.image">
                        <div class="avatar-content">{{courseData?.title | shortName }}</div>
                      </div>  -->
                      <div
                      *ngIf="!imgUrl && !courseData?.image"
                      [class.initial-alpha]="!courseData?.image"
                      class="users-avatar-shadow mr-1 ml-0 bg-primary"
                    >
                      <div class="avatar-content">
                        {{ courseData?.title | titlecase | shortName }}
                      </div>
                    </div>


                      <div class="media-body">
                        <h4>{{ courseData?.title | titlecase | shortName}}</h4>
                        <div
                          class="d-flex flex-sm-row flex-column justify-content-start px-0 mb-sm-2"
                        >
                          <label
                            class="btn btn-sm btn-primary mb-1 mb-sm-0 text-transform-unset"
                            >Change
                            <input
                              type="file"
                              #fileInput
                              class="form-control"
                              (change)="onSelectFile($event)"
                              hidden
                            />
                          </label>
                          <button
                            class="btn btn-sm bg-light-secondary ml-sm-2"
                            (click)="resetImage()"
                          >
                            Reset
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Media object ends -->

                    <!-- Account form starts -->

                    <div class="row">
                      <div class="col-md-6">
                        <form >
                          <fieldset class="form-group">
                            <label> Title<span class="required_field">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]="courseData.title"
                            [ngModelOptions]="{ standalone: true }" id="title" placeholder="Enter title"
                              />
                          </fieldset>
                          <fieldset class="form-group">
                            <label>About</label>
                            <input type="text" class="form-control" [(ngModel)]="courseData.about"
                            [ngModelOptions]="{ standalone: true }" id="name" placeholder="Enter about"
                              />
                          </fieldset>
                          
                          <fieldset class="form-group">
                            <label>Total Fees<span class="required_field">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]="courseData.total_fees"
                            [ngModelOptions]="{ standalone: true }" id="total_fees"
                              placeholder="Enter total fees" />
                          </fieldset>
                          <fieldset class="form-group">
                            <label>Min Fees</label>
                            <input type="text" class="form-control" [(ngModel)]="courseData.minfees"
                            [ngModelOptions]="{ standalone: true }" id="min_fees"
                              placeholder="Enter min fees" />
                            
                          </fieldset>
                          <fieldset class="form-group">
                            <label>Max Fees</label>
                            <input type="text" class="form-control" [(ngModel)]="courseData.maxfees"
                            [ngModelOptions]="{ standalone: true }" id="max_fees"
                              placeholder="Enter max fees"  />
                            
                          </fieldset>
                          <fieldset class="form-group">
                            <label>Service And Offer</label>
                            <input type="text" class="form-control" [(ngModel)]="courseData.serviceandoffer"
                            [ngModelOptions]="{ standalone: true }" id="serviceandoffer"
                              placeholder="Enter service and offer"/>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>course_type<span class="required_field">*</span></label>
                              <ng-select [items]="course_type_List" bindLabel="displayname" bindValue="_id"
                              placeholder="Select Course type" [(ngModel)]="selected_course_type"
                              [ngModelOptions]="{ standalone: true }" (change)="getCourseTypeId($event)" [closeOnSelect]="false">
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>instructor<span class="required_field">*</span></label>
                            <ng-select [items]="fullpart_employee_list" bindLabel="name" bindValue="Empid"
                              placeholder="Select instructor" [(ngModel)]="selected_instructor"
                              [ngModelOptions]="{ standalone: true }" (change)="getinstructorId($event)" [closeOnSelect]="false">
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>language<span class="required_field">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]="courseData.language"
                            [ngModelOptions]="{ standalone: true }" id="language"
                              placeholder="Enter language"/>
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="preliminary">preliminary</label>
                            <textarea [(ngModel)]="courseData.preliminary"
                            [ngModelOptions]="{ standalone: true }" id="hidden-label-form-6" rows="2" class="form-control"
                              name="comment2" placeholder="Enter preliminary"></textarea>
                           
                          </fieldset>
                          <fieldset class="form-group">
                            <label>Benifits</label>
                            <textarea [(ngModel)]="courseData.benifits"
                            [ngModelOptions]="{ standalone: true }" id="hidden-label-form-6" rows="4" class="form-control"
                              name="comment2" placeholder="Enter benifits" ></textarea>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>Learning Audience</label>
                            <textarea [(ngModel)]="courseData.learning_audience"
                            [ngModelOptions]="{ standalone: true }" id="hidden-label-form-6" rows="4" class="form-control"
                              name="comment2" placeholder="Enter learning audience" ></textarea>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>Outcome</label>
                            <textarea [(ngModel)]="courseData.outcome"
                            [ngModelOptions]="{ standalone: true }" id="hidden-label-form-6" rows="4" class="form-control"
                              name="comment2" placeholder="Enter outcome" ></textarea>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>Objective</label>
                            <textarea [(ngModel)]="courseData.objective"
                            [ngModelOptions]="{ standalone: true }" id="hidden-label-form-6" rows="4" class="form-control"
                              name="comment2" placeholder="Enter objective" ></textarea>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>promotional video</label>
                            <textarea [(ngModel)]="courseData.promotional_video"
                            [ngModelOptions]="{ standalone: true }" id="hidden-label-form-6" rows="4" class="form-control"
                              name="comment2" placeholder="Enter promotional video" ></textarea>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>Announcements</label>
                            <textarea [(ngModel)]="courseData.announcements"
                            [ngModelOptions]="{ standalone: true }" name="announcements" class="form-control" id="announcements" placeholder="Enter Announcements" cols="30" rows="4"></textarea>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>notes</label>
                            <textarea [(ngModel)]="courseData.notes"
                            [ngModelOptions]="{ standalone: true }" id="hidden-label-form-6" rows="2" class="form-control"
                              name="comment2" placeholder="Enter notes" ></textarea>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>Admin Notes</label>
                            <textarea [(ngModel)]="courseData.admin_notes"
                            [ngModelOptions]="{ standalone: true }" id="hidden-label-form-6" rows="2" class="form-control"
                              name="comment2" placeholder="Enter admin_notes" ></textarea>
                            
                          </fieldset>
        
                        </form>
                      </div>
                      <div class="col-md-6">
                        <form >
                         
                          <fieldset class="form-group">
                            <label>mode<span class="required_field">*</span></label>
                            <ng-select [items]="mode_List" bindLabel="displayname" bindValue="_id"
                              placeholder="Select mode" [(ngModel)]="selected_mode" [multiple]="true"
                              [ngModelOptions]="{ standalone: true }" (change)="getModeId($event)" [closeOnSelect]="false">
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>offers<span class="required_field">*</span></label>
                            <ng-select [items]="offers_list" bindLabel="displayname" bindValue="_id"
                              placeholder="Select last publishers" [(ngModel)]="selected_discount"
                              [ngModelOptions]="{ standalone: true }" (change)="getDiscountId($event)" [closeOnSelect]="false">
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>proof readers<span class="required_field">*</span></label>
                            <ng-select [items]="fullpart_employee_list" bindLabel="name" bindValue="Empid"
                              placeholder="Select proof readers" [(ngModel)]="selected_proofread"
                              [ngModelOptions]="{ standalone: true }" (change)="getProofreadId($event)" [closeOnSelect]="false">
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>publishers<span class="required_field">*</span></label>
                            <ng-select [items]="fullpart_employee_list" bindLabel="name" bindValue="Empid"
                              placeholder="Select publishers" [(ngModel)]="selected_publisher"
                              [ngModelOptions]="{ standalone: true }" (change)="getPublisherId($event)" [closeOnSelect]="false">
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>last published by<span class="required_field">*</span></label>
                            <ng-select [items]="fullpart_employee_list" bindLabel="name" bindValue="Empid"
                              placeholder="Select last publishers" [(ngModel)]="selected_last_publisher"
                              [ngModelOptions]="{ standalone: true }" (change)="getLastPublisherId($event)" [closeOnSelect]="false">
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>projects<span class="required_field">*</span></label>
                            <ng-select [items]="project_list" bindLabel="name" bindValue="_id"
                              placeholder="Select project" [(ngModel)]="selected_project"
                              [ngModelOptions]="{ standalone: true }" (change)="getProjectId($event)" [closeOnSelect]="false">
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>resources<span class="required_field">*</span></label>
                            <ng-select [items]="resource_list" bindLabel="content" bindValue="id"
                            placeholder="Select last publishers" [(ngModel)]="selected_resource"
                            [ngModelOptions]="{ standalone: true }" (change)="getResourceId($event)" [closeOnSelect]="false">
                          </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>duration<span class="required_field">*</span></label>
                            <ng-select [items]="duration_List" bindLabel="displayname" bindValue="_id"
                              placeholder="Select Duration" [(ngModel)]="selected_duration"
                              [ngModelOptions]="{ standalone: true }" (change)="getDurationId($event)" [closeOnSelect]="false">
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>level<span class="required_field">*</span></label>
                            <ng-select [items]="level_List" bindLabel="displayname" bindValue="_id"
                              placeholder="Select level" [(ngModel)]="selected_level"
                              [ngModelOptions]="{ standalone: true }" (change)="getLevelId($event)" [closeOnSelect]="false">
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>grading</label>
                            <input type="text" class="form-control" [(ngModel)]="courseData.grading"
                            [ngModelOptions]="{ standalone: true }" id="grading"
                              placeholder="Enter grading"/>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>certification</label>
                            <input type="text" class="form-control" [(ngModel)]="courseData.certification"
                            [ngModelOptions]="{ standalone: true }" id="certification"
                              placeholder="Enter certification"/>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>published_datetime</label>
                            <input type="datetime-local" class="form-control" [(ngModel)]="courseData.published_datetime"
                            [ngModelOptions]="{ standalone: true }"  id="published_datetime"
                              placeholder="Enter published_datetime"/>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>version</label>
                            <input type="text" class="form-control" [(ngModel)]="courseData.version"
                            [ngModelOptions]="{ standalone: true }" id="version"
                              placeholder="Enter version"/>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>LMS<span class="required_field">*</span></label>
                            <ng-select [items]="lmsData" bindLabel="title" bindValue="id"
                              placeholder="Select LMS ID" [multiple]="true"
                              [closeOnSelect]="false"  [(ngModel)]="this.selectedLms"
                              [ngModelOptions]="{ standalone: true }" (change)="getLmsV1ById($event)">
                            </ng-select>
                          </fieldset>
                         
                          <fieldset class="form-group">
                            <label>course category<span class="required_field">*</span></label>
                            <ng-select [items]="categoryList" bindLabel="displayname" bindValue="_id"
                              placeholder="Select Course Interest" [(ngModel)]="selectedCategory"
                              [ngModelOptions]="{ standalone: true }" (change)="getCategoryId($event)" [closeOnSelect]="false">
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>course skills<span class="required_field">*</span></label>
                            <ng-select [items]="tagsList" bindLabel="displayname" bindValue="_id" [multiple]="true"
                              [closeOnSelect]="false" placeholder="Select Skill" [(ngModel)]="selectedTag"
                              [ngModelOptions]="{ standalone: true }" (change)="getTagsId($event)">
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>Variation<span class="required_field">*</span></label>
                            <ng-select [items]="variationList" bindLabel="displayname" bindValue="_id"
                              placeholder="Select Variation" [(ngModel)]="selectedVariation"
                              [ngModelOptions]="{ standalone: true }" (change)="getVariationId($event)" [closeOnSelect]="false">
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>course tags<span class="required_field">*</span></label>
                            <ng-select [items]="courseTagsList" bindLabel="displayname" bindValue="_id"
                              placeholder="Select Course Tags" [(ngModel)]="selectedCourseTag"
                              [ngModelOptions]="{ standalone: true }" (change)="getCourseTagId($event)" [closeOnSelect]="false">
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>Batch<span class="required_field">*</span></label>
                            <ng-select [items]="batchList" bindLabel="name" bindValue="_id" placeholder="Select Batch"
                              [(ngModel)]="selectedBatch" [ngModelOptions]="{ standalone: true }" (change)="getBatchId($event)" [closeOnSelect]="false">
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label class="form-control-label" for="Employeetype">
                             Category Tags<span class="required_field">*</span>
                            </label>
                            <ng-select
                              [items]="category_tags_list"
                              bindLabel="displayname"
                              bindValue="_id"
                              placeholder="Select Category Tags"
                              [(ngModel)]="selected_category_tags"
                              [ngModelOptions]="{ standalone: true }"
                              (change)="getCategoryTagsId($event)"
                              [closeOnSelect]="false"
                            >
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>Published Web<span class="required_field">*</span></label>
                            <ng-select [items]="publish_List" bindLabel="displayname" bindValue="_id"
                              placeholder="Select Published Web" [(ngModel)]="selected_publish_web"
                              [ngModelOptions]="{ standalone: true }" (change)="getPublishWebId($event)" [closeOnSelect]="false">
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>Published App<span class="required_field">*</span></label>
                            <ng-select [items]="publish_List" bindLabel="displayname" bindValue="_id"
                              placeholder="Select Published App" [(ngModel)]="selected_publish_app"
                              [ngModelOptions]="{ standalone: true }" (change)="getPublishAppId($event)" [closeOnSelect]="false">
                            </ng-select>
                          </fieldset>
                          <!-- <fieldset class="form-group">
                            <input type="file" class="form-control" formControlName="image" required
                              (change)="onSelectFile($event)" />
                          </fieldset> -->
                          <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2">
                            <button type="submit" class="btn btn-primary mb-2 mb-sm-0 mr-sm-2" 
                              (click)="submit()">
                              Submit
                            </button>
                            <button type="reset" class="btn btn-secondary" (click)="back()">
                              Cancel
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>

                    <!-- <form>
                      <div class="row">
                        <div class="col-md-6">
                          <fieldset class="form-group">
                            <label for="title">Title</label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="courseData.title"
                              [ngModelOptions]="{ standalone: true }"
                              id="name"
                              placeholder="Enter Title Name"
                              #title
                            />
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="about">About</label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="courseData.about"
                              [ngModelOptions]="{ standalone: true }"
                              id="about"
                              placeholder="Enter about"
                              #about
                            />
                          </fieldset>
                          <fieldset class="form-group">
                            <label>Preliminary</label>
                            <textarea
                              rows="2"
                              class="form-control"
                              [(ngModel)]="courseData.preliminary"
                              [ngModelOptions]="{ standalone: true }"
                              id="preliminary"
                              placeholder="Enter preliminary"
                              #preliminary
                            ></textarea>
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="total_fees">Total Fees</label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="courseData.total_fees"
                              [ngModelOptions]="{ standalone: true }"
                              id="fees"
                              placeholder="Enter Total Fees"
                            />
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="benifits">Benifits</label>
                            <textarea
                              id="hidden-label-form-6"
                              rows="2"
                              [(ngModel)]="courseData.benifits"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              name="comment2"
                              placeholder="Enter  benifits"
                              #benifits
                            ></textarea>
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="notes">notes</label>
                            <textarea
                              id="hidden-label-form-6"
                              rows="2"
                              [(ngModel)]="courseData.notes"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              name="comment2"
                              placeholder="Enter  notes"
                              #notes
                            ></textarea>
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="admin_notes">admin_notes</label>
                            <textarea
                              id="hidden-label-form-6"
                              rows="4"
                              [(ngModel)]="courseData.admin_notes"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              name="comment2"
                              placeholder="Enter  admin_notes"
                            ></textarea>
                          </fieldset>
                        </div>
                        <div class="col-md-6">
                          <fieldset class="form-group">
                            <label>LMS ID</label>
                            <ng-select
                              [items]="lmsData"
                              bindLabel="title"
                              bindValue="id"
                              placeholder="Select LMS ID"
                              [multiple]="true"
                              [closeOnSelect]="false"
                              [(ngModel)]="selectedLms"
                              [ngModelOptions]="{ standalone: true }"
                              (change)="getLmsV1ById($event)"
                            >
                            </ng-select>
                          </fieldset>

                          <fieldset class="form-group">
                            <label for="durations">Announcements</label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="courseData.announcements"
                              [ngModelOptions]="{ standalone: true }"
                              id="durations"
                              placeholder="Enter Course Durations"
                              #announcements
                            />
                          </fieldset>

                          <fieldset class="form-group">
                            <label for="">Course Interest</label>
                            <ng-select
                              [items]="categoryList"
                              bindLabel="displayname"
                              bindValue="_id"
                              placeholder="Select Course Interest"
                              [(ngModel)]="selectedCategory"
                              [ngModelOptions]="{ standalone: true }"
                              (change)="getCategoryId($event)"
                            >
                            </ng-select>
                          </fieldset>
                         
                          <fieldset class="form-group">
                            <label>Course Skill</label>
                            <ng-select
                              [items]="tagsList"
                              bindLabel="displayname"
                              bindValue="_id"
                              [multiple]="true"
                              [closeOnSelect]="false"
                              placeholder="Select Skill"
                              [(ngModel)]="selectedTag"
                              [ngModelOptions]="{ standalone: true }"
                              (change)="getTagsId($event)"
                            >
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label> Variation</label>
                            <ng-select
                              [items]="variationList"
                              bindLabel="displayname"
                              bindValue="_id"
                              placeholder="Select Variation"
                              [(ngModel)]="selectedVariation"
                              [ngModelOptions]="{ standalone: true }"
                              (change)="getVariationId($event)"
                            >
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>Course Tags</label>
                            <ng-select
                              [items]="courseTagsList"
                              bindLabel="displayname"
                              bindValue="_id"
                              placeholder="Select Course Tags"
                              [(ngModel)]="selectedCourseTag"
                              [ngModelOptions]="{ standalone: true }"
                              (change)="getCourseTagId($event)"
                            >
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>Batch</label>
                            <ng-select
                              [items]="batchList"
                              bindLabel="name"
                              bindValue="_id"
                              placeholder="Select Batch"
                              [(ngModel)]="selectedBatch"
                              [ngModelOptions]="{ standalone: true }"
                              (change)="getBatchId($event)"
                            >
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label class="form-control-label" for="Employeetype">
                             Category Tags
                            </label>
                            <ng-select
                              [items]="category_tags_list"
                              bindLabel="displayname"
                              bindValue="_id"
                              placeholder="Select Category Tags"
                              [(ngModel)]="selected_category_tags"
                              [ngModelOptions]="{ standalone: true }"
                              (change)="getCategoryTagsId($event)"
                            >
                            </ng-select>
                          </fieldset>
                         
                          <div
                            class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2"
                          >
                            <button
                              type="submit"
                              class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                              (click)="submit()"
                            >
                              Submit
                            </button>
                            <button
                              type="reset"
                              class="btn btn-secondary"
                              (click)="back()"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </form> -->
                    <!-- Account form ends -->
                  </div>
                  <!-- Account content ends -->
                </ng-template>
              </li>
            </ul>
            <div class="tab-content">
              <div [ngbNavOutlet]="nav"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
